var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-footer',[_c('span',{staticClass:"el-footer__text"},[_vm._v("Kalkınma Yatırım Bankası A.Ş. Copyright © 2020")]),_c('span',{staticClass:"el-footer__text"},[_c('span',{staticClass:"icon-phone"}),_vm._v(" 0 (216) 636 87 00")])])
}
var staticRenderFns = []

export { render, staticRenderFns }